import React from "react";
import {useTranslation} from "react-i18next";

import { Check as CheckIcon, Completed } from '@vedmarket/ui-kit';
import Typography from '@mui/material/Typography';
import {COLORS} from 'config/constants';
import Button from "@mui/material/Button";

import {useGetCalcIdFromRoute} from "../../../../../../../../../utils/hooks";
import {useDemoPackagingAction} from 'components/cabinet/demo/steps/packaging/use-packaging';
import {
  useAddServicesToRouteByOrderIdMutation,
  useSetCompletedByOrderIdMutation
} from "../../../../../../../../../api/calc";

import './combined-cargo.scss'
import {METHODS} from "../../index";
import {numberWithSpaces} from "../../../../../../../../../utils/helpers";

const CombinedCargo = ({ handleSave, summary }: PackagingCombinedCargoProps) => {

  const demoPlayback = useDemoPackagingAction({
    action: 'confirm-delivery-method',
    isAllowed: true,
  })

  const { t } = useTranslation()

  const orderId = useGetCalcIdFromRoute()

  const [ setCompleted ] = useSetCompletedByOrderIdMutation()

  const [ addServices ] = useAddServicesToRouteByOrderIdMutation()

  const handleSaveCombinedCargo = async() => {

    if (summary?.delivery_type === METHODS.CONTAINERS){
      await addServices({
        orderId,
        route: null,
        services: []
      });

      await setCompleted({
        orderId,
        delivery: false,
        customs: false,
        additional_services: false,
        banking_commissions: false,
        certification: false,
      })
    }

    if (handleSave) {
      handleSave();
    }
  }

  const info = [
    {
      label: t('calc__text__delivery__airfreight'),
      value: <>{numberWithSpaces(summary.volume_weight.avia)} {t('units__text__kg')}/{t('units__text__meter')}<Typography component='sup' variant='inherit' sx={{fontSize: '0.645em', lineHeight: 0}}>3</Typography></>,
    },
    {
      label: t('calc__text__delivery__seafreight'),
      value: <>{numberWithSpaces(summary.volume_weight.sea)} {t('units__text__kg')}/{t('units__text__meter')}<Typography component='sup' variant='inherit' sx={{fontSize: '0.645em', lineHeight: 0}}>3</Typography></>,
    },
    {
      label: t('calc__text__delivery__railwayFreight'),
      value: <>{numberWithSpaces(summary.volume_weight.rails)} {t('units__text__kg')}/{t('units__text__meter')}<Typography component='sup' variant='inherit' sx={{fontSize: '0.645em', lineHeight: 0}}>3</Typography></>,
    },
  ];

  return <div className='packaging-combined-cargo'>
    <div className='packaging-combined-cargo__weight'>
      <Typography
        variant='body2'
        sx={{
          fontWeight: 500,
          color: COLORS.BLACK_DARK,
          lineHeight: '21px',
        }}
      >{t('calc__text__packaging__volumetricWeight')}</Typography>
      <Completed info={info} isFullRow noPadding backgroundColor={COLORS.GRAY_200} />
    </div>
    {handleSave && <Button
      {...demoPlayback.buttonProps}
      variant='contained'
      fullWidth
      onClick={handleSaveCombinedCargo}
      startIcon={<CheckIcon/>}
    >
      <Typography component='span' variant='button'>
        {t('actions__text__confirmDeliveryMethodCollectShipment')}
      </Typography>
    </Button>}
  </div>
}

export default CombinedCargo
